import React from 'react';
// import Matricula from "./pages/Matricula.js";
// import Home from './Home'
import iconlocation from '../images/pin-location.png';
import iconemail from '../images/envelope-email.png';
import iconphone from '../images/phone.png';
import AddressMap from './GoogleMap.js';
import {
  // BrowserRouter as Router,
  // Switch,
  // Routes,
  // Route,
  Link
} from "react-router-dom";

export class MenuFooter extends React.Component {
	render() {

		return (
			<>
				<div className="footerCol">
					<ul className="footerMenu">
						<li><Link to="/">Inicio</Link></li>
						<li><a href="#">Nosotros</a></li>
						<li><a href="#">Servicios</a></li>
						<li><a href="#">Visión Ambiental</a></li>
						<li><a href="#">Testimoniales</a></li>
						<li><a href="#">Servicios</a></li>
						<li><Link to="/matricula">Matrícula</Link></li>
					</ul>
				</div>

				<div className="footerCol">
					<ul className="footerMenu">
						<li><a href="#">Nursery</a></li>
						<li><a href="#">Preescolar</a></li>
						<li><a href="#">Primaria</a></li>
						<li><a href="#">Secundaria</a></li>
					</ul>
				</div>

				<div className="footerCol">
					<ul className="contacInfo">
						<li><img src={iconlocation}/> Moravia - San Vicente 100 m este, 500 mts. norte<br/> y 150 mts. oeste de Plaza Lincoln.</li>

						<li><img src={iconemail} alt="email"/><a href="recepcion@ipicim.ed.cr">recepcion@ipicim.ed.cr</a></li>

						<li><img src={iconphone} alt="telefono"/>
						<a href="tel:22406034">2240-6034</a> / <a href="tel:22367022">2236-7022</a></li>
					</ul>
				</div>

				<div className="footerCol">
					<div className="googleMapFooter">
							<AddressMap/>
					</div>
				</div>

			</>
		)
	}
}

	export default MenuFooter